<template>
  <section class="h-screen font-sans bg-cover">
    <div class="container mx-auto h-full flex flex-1 justify-center items-center">
      <form @submit="next()" class="max-w-sm w-96 m-4 py-8 px-10 bg-white rounded shadow-xl ">

        <div class="content">
          <h2 class="mb-4 font-bold text-xl">Create your workspace</h2>

          <div v-if="currentStep === 1">
            <label class="cursor-pointer w-full mb-4 block">
              <span class="block mb-2">What is the name of the workspace ?</span>
              <input v-model="fields.name" type="text" placeholder="Enter a name" class="px-3 py-3 placeholder-gray-400 text-gray-700 relative bg-white bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full">
            </label>

            <label class="cursor-pointer w-full mb-4 block">
              <span class="block mb-2">What is the description ?</span>
              <input v-model="fields.description" type="text" placeholder="Enter a description" class="px-3 py-3 placeholder-gray-400 text-gray-700 relative bg-white bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full">
            </label>

            <label class="cursor-pointer w-full mb-4 block">
              <span class="block mb-2">Where the workspace will be run ?</span>
              <input v-model="fields.url" type="text" placeholder="Enter a valid url" class="px-3 py-3 placeholder-gray-400 text-gray-700 relative bg-white bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full">
            </label>
          </div>

          <div v-if="currentStep === 2">
            <label class="cursor-pointer w-full mb-4 block">
              <span class="block mb-2">What is the firstname of the contact ?</span>
              <input v-model="fields.contact.fname" type="text" placeholder="Enter a firstname" class="px-3 py-3 placeholder-gray-400 text-gray-700 relative bg-white bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full">
            </label>

            <label class="cursor-pointer w-full mb-4 block">
              <span class="block mb-2">What is the lastname of the contact ?</span>
              <input v-model="fields.contact.lname" type="text" placeholder="Enter a lastname" class="px-3 py-3 placeholder-gray-400 text-gray-700 relative bg-white bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full">
            </label>

            <label class="cursor-pointer w-full mb-4 block">
              <span class="block mb-2">Where is the email of the contact ?</span>
              <input v-model="fields.contact.email" type="text" placeholder="Enter a valid email" class="px-3 py-3 placeholder-gray-400 text-gray-700 relative bg-white bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full">
            </label>

            <label class="cursor-pointer w-full mb-4 block">
              <span class="block mb-2">Where is the phone of the contact ?</span>
              <input v-model="fields.contact.phone" type="text" placeholder="Enter a valid phone" class="px-3 py-3 placeholder-gray-400 text-gray-700 relative bg-white bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full">
            </label>
          </div>

        </div>

        <div class="mt-8 text-right">
          <common-button
            v-if="currentStep === 1"
            type="secondary"
            @click="$router.push({name: 'WorkspaceList'})">Cancel</common-button>
          <common-button
            v-if="currentStep === 2"
            type="secondary"
            @click="currentStep = 1">Previous</common-button>

          <common-button
            v-if="currentStep === 1"
            :disabled="!isStepValid()"
            type="primary"
            :submit="true"
            @click="next()">Next</common-button>
          <common-button
            v-if="currentStep === 2"
            :disabled="!isStepValid()"
            :is-loading="isCreating"
            type="primary"
            :submit="true"
            @click="next()">Create</common-button>
        </div>
      </form>

      <h1 class="font-logo text-4xl ml-10"><span class="text-gray-600">Rocket</span><span class="text-primary">fid</span></h1>
    </div>
  </section>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'WorkspaceCreate',
  data () {
    return {
      currentStep: 1,
      isCreating: false,

      fields: {
        name: null,
        description: null,
        url: null,
        contact: {
          fname: null,
          lname: null,
          email: null,
          phone: null
        }
      }
    }
  },
  computed: {
    ...mapGetters('account', {
      sites: 'sites'
    })
  },
  methods: {
    ...mapActions('account', {
      addSite: 'addSite'
    }),
    isStepValid (step) {
      if (!step) {
        step = this.currentStep
      }

      switch (step) {
      case 1:
        return this.fields.name && this.fields.description && this.fields.url
      case 2:
        return this.isStepValid(1) && this.fields.contact.fname && this.fields.contact.lname && this.fields.contact.email && this.fields.contact.phone
      default:
        return false
      }
    },

    next () {
      if (!this.isStepValid()) {
        return false
      }

      if (this.currentStep === 1) {
        this.currentStep = 2
        return
      }

      if (this.currentStep === 2) {
        this.createWorkspace()
      }
    },

    async createWorkspace () {
      this.fields.languages = [{ lang: 'fr' }]
      this.isCreating = true

      await new Promise(resolve => setTimeout(resolve, 1000))

      this.addSite(this.fields).then(() => {
        this.$notify({
          title: 'Success',
          message: this.$root.$t('notifications.site.added'),
          type: 'success'
        })
        this.isCreating = false

        this.$router.push({name: 'WorkspaceList'})
      }).catch((response) => {
        this.$notify.error({
          title: this.$root.$t('api.' + response.code + '.title'),
          message: this.$root.$t('api.' + response.code + '.message')
        })
        this.isCreating = false
      })
    }
  },
  mounted () {
    if (this.sites && this.sites.length === 1) {
      // this.$router.push({name: 'campaigns', params: {site: this.sites[0].sitekey}})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Workspace/WorkspaceCreate.vue